import RestService from "./rest.service";

class inboxService {
  getRoute(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets("app/kpi/evaluate/360/" + id + "/route").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}



export default new inboxService();
